import gameInfoConfig from '@configs/officialStore/globalGameInfoConfig';
import { mapState, mapGetters } from 'vuex';
import { INIT_WELFARE_BTN } from '@store/officialStore/index';

export default {
  computed: {
    ...mapState({
      gameId: state => state.gameId,
      hasLoadPaytype: state => state.hasLoadPaytype,
      isLogin: state => state.login.isLogin,
      boolInitWelfareBtnRecord: state => state.boolInitWelfareBtnRecord
    }),
    ...mapGetters(['isJpPlatform', 'showRightsCenter']),
    isShowVipScore() {
      if (gameInfoConfig[+this.gameId].isBlackFridayVersion) {
        return false;
      }
      if (gameInfoConfig[+this.gameId].isUpdateNewVersion) {
        return false;
      }
      return (
        gameInfoConfig[+this.gameId].isVipScore &&
        this.$route.path !== '/vip_score'
      );
    },
    showVipBtn() {
      return (
        //显示逻辑更改
        // this.isShowVipScore &&
        !this.isShowVipScore &&
        !this.hasLoadPaytype &&
        this.isLogin &&
        !this.isUidTypeAndHideVipCoupon &&
        !this.showRightsCenter
      );
    },
    showShareBtn() {
      return gameInfoConfig[+this.gameId].isShowShareBtn;
    },
    // 控制显示按钮 新旧版是否合并
    showCouponBtn() {
      return gameInfoConfig[this.gameId].isHeaderCoupon;
    },
    showWalletBtn() {
      if (!gameInfoConfig[+this.gameId].isShowWallet) {
        return false;
      }
      if (gameInfoConfig[+this.gameId].isUpdateNewVersion) {
        return true;
      }
    },
    showWelfareBtn() {
      if (this.isJpPlatform) {
        return false;
      }
      if (['bankInfo', 'result', 'browserPay'].includes(this.$route.name)) {
        return false;
      }
      if (gameInfoConfig[+this.gameId].isBlackFridayVersion) {
        return true;
      }
      if (!gameInfoConfig[+this.gameId].isUpdateNewVersion) {
        return false;
      }
      // 调整福利弹窗的显示逻辑
      return (
        this.showVipBtn ||
        this.showShareBtn ||
        this.showCouponBtn ||
        this.showWalletBtn
      );
    }
  },
  methods: {
    initWelfareBtn() {
      if (this.boolInitWelfareBtnRecord) {
        return;
      }
      const recordBtnArr = [];
      this.showVipBtn && recordBtnArr.push('vipBtn');
      this.showShareBtn && recordBtnArr.push('shareBtn');
      this.showCouponBtn && recordBtnArr.push('couponBtn');
      this.showWalletBtn && recordBtnArr.push('walletBtn');

      this.$store.commit(INIT_WELFARE_BTN, recordBtnArr);
    }
  },
  created() {
    this.initWelfareBtn();
  }
};
